<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                containerForm: () => import('../forms/ContainerForm'),
                saleForm: () => import('../forms/SaleForm'),
                fields: [
                    { type: 'autocomplete', text: 'Sale', value: 'saleId', rules: [v => !!v || 'Sale is required'], isRequired: true, form: () => import('./SaleForm'), apiMethod: 'Sales', claim: 'Sales' },
                    { type: 'autocomplete', text: 'Seller Container', value: 'sellerContainerId', rules: [v => !!v || 'Seller Container is required'], isRequired: true, form: () => import('./ContainerForm'), apiMethod: 'Containers', claim: 'Containers' },
                    { type: 'autocomplete', text: 'Buyer Container', value: 'buyerContainerId', rules: [], form: () => import('./ContainerForm'), apiMethod: 'Containers', claim: 'Containers' },
                ],
                apiMethod: 'SaleContainers',
                formTitle: 'Sale Container',
            }
        },
    };
</script>
